<div class="dropdown d-flex header-drops">
  <a class="dropdown-toggle header-notifications dropdown-menu-left" id="dropdownMenuButton" (click)="toggleNotification()">
    <img src="/public/resources/images/notification-not-active.svg" alt="Notifications" />
  </a>
  <ul class="dropdown-menu header-notifications-menu dropdown-menu-left" *ngIf="notificationFlag">
    <li *ngFor="let notification of notifications; let n = index">
      <a class="dropdown-item new_noti" [routerLink]="notification.notificationLink" (click)="closeNotification()">
        <div class="clearfix flex-box">
          <div class="noti_ico"><i class="type"></i></div>
          <div class="noti_data" *ngIf="notification.notificationText">
            {{ notification.notificationText.textAr }}
            <p class="time speero-date">{{ notification.createdAt | date: 'yyyy/MM/dd hh:mm a' }}</p>
          </div>
        </div>
      </a>
    </li>
    <li *ngIf="!notifications.length">
      لا يوجد لديك تنبيهات جديدة
    </li>
  </ul>
</div>
